import axios from "axios";
import { baseURL } from './configData';

// const token = localStorage.getItem('auth_token');

const lang_code = localStorage.getItem("langCode") || 'en';


const axiosInstance = axios.create({
    baseURL,
    // timeout: 5000,
    headers: {
        'version': '4',
        'Accept': 'application/json',
        // 'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept-Language': lang_code
    }
});

export default axiosInstance;